// HOOKS
import useUnauthenticatedPasswordReset from "../../../../hooks/users/useUnauthenticatedPasswordReset.hook";
import { useState } from "react";
import DefaultButton from "../../../../components/buttons/default.button";

const CLASSNAMES = {
  form: "w-content border-animate rounded-2xl shadow-lg  flex flex-col justify-center items-center gap-4 p-8 bg-gray-200",
  container: "gap-2 p-2 flex flex-col w-full justify-between",
  label: "text-secondary capitalize font-ubuntuBold flex justify-start",
  input:
    "w-[400px] text-secondary shadow focus:shadow-primary px-4 py-2 font-ubuntuMedium rounded flex justify-end focus:outline-none",
};

const Page = ({ classNames = CLASSNAMES }) => {
  const { resetPassword } = useUnauthenticatedPasswordReset();
  const [password, setPassword] = useState("");

  // Set the password state
  const handleChange = (event) => {
    setPassword(event.target.value);
  };

  const handleClick = (event) => {
    event.preventDefault();
    resetPassword(password);
  };
  return (
    <form className={classNames?.form || CLASSNAMES.form}>
      <div className={classNames?.container || CLASSNAMES.container}>
        <label
          className={classNames?.label || CLASSNAMES.label}
          htmlFor="password"
        >
          New Password
        </label>
        <input
          className={classNames?.input || CLASSNAMES.input}
          type="password"
          id="password"
          name="password"
          value={password}
          onChange={handleChange}
        />
      </div>
      <DefaultButton handleClick={handleClick}>Save</DefaultButton>
    </form>
  );
};

export default Page;
